import React from "react";
import { Carousel } from "react-bootstrap";

const HappyHoliday = () => {
  return (
    <div className="roadRiderzProject">
      <h1 className="projects-Header">Happy Holiday Tourism</h1>
      <div className="row site-details-rrz">
        <div className="col-md-6 p-2">
          <p>
           * User can book their selected tour package and vew their order detail
            on My Order page.
          </p>
          <p>
            * Happy Holiday is online resort booking website with offering best price.
          </p>
          <p>* Implement CRUD operation and using MERN, so user book packages, update and remove order</p>
          <p>
            * Using technologies are ReactJS, React Bootstrap, NodeJS,
            ExpressJS, MongoDB, Firebase, Heroku.
          </p>
          <p>* This site all device responsive and aslo implement firebase Authentication systen</p>
          <p>* To protect women rights and ensure their participation in the tourism sector</p>
        </div>
        <div className="col-md-6 p-2">
          <Carousel fade>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src="https://i.postimg.cc/mk509RTM/Screenshot-46-1.png"
                alt="First slide"
              />
              <Carousel.Caption>
                {/* <h3>First slide label</h3>
                  <p>
                    Nulla vitae elit libero, a pharetra augue mollis interdum.
                  </p> */}
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src="https://i.postimg.cc/6QpgMyTR/Screenshot-45-1.png"
                alt="Second slide"
              />

              <Carousel.Caption>
                {/* <h3>Second slide label</h3>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p> */}
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src="https://i.postimg.cc/FFLqCtFP/Screenshot-44-1.png"
                alt="Third slide"
              />

              <Carousel.Caption>
                {/* <h3>Third slide label</h3>
                  <p>
                    Praesent commodo cursus magna, vel scelerisque nisl
                    consectetur.
                  </p> */}
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src="https://i.postimg.cc/QtLgHzLt/Screenshot-43-1.png"
                alt="Third slide"
              />

              <Carousel.Caption>
                {/* <h3>Fourth slide label</h3>
                  <p>
                    Praesent commodo cursus magna, vel scelerisque nisl
                    consectetur.
                  </p> */}
              </Carousel.Caption>
            </Carousel.Item>
          </Carousel>
        </div>
      </div>
      <div className="siteInfo">
        <h3 className="seeLive">See Live: </h3>
        <span>
          {" "}
          <a
            className="liveSite"
            target="_blank"
            href="https://haapy-holiday.web.app/"
          >
            <b>LiveSite</b>
          </a>
        </span>
        <span>
          <a
            className="clientSide"
            target="_blank"
            href="https://github.com/Iasir-Arafat-riaz/HappyHoliday-Tourism-CLientSide"
          >
            <b>ClientSideCode</b>
          </a>
        </span>
        <span>
          <a
            className="serverSide"
            target="_blank"
            href="https://github.com/Iasir-Arafat-riaz/HappyHoliday-Tourism-Node-Mongo-Server"
          >
            <b>ServerSideCode</b>
          </a>
        </span>
      </div>
    </div>
  );
};

export default HappyHoliday;
